import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Panel, Stars, Select, fmtDT } from "@/components/admin/ui";

export default function CompanyFeedback() {
  const [stores, setStores] = useState([]);
  const [items, setItems] = useState([]);
  const [storeId, setStoreId] = useState("");
  const [rating, setRating] = useState("");

  useEffect(() => { api.get("/stores").then((r) => setStores(r.data)); }, []);
  useEffect(() => { api.get(`/feedback${storeId ? `?store_id=${storeId}` : ""}`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [storeId]);

  const shown = rating ? items.filter((i) => i.rating === Number(rating)) : items;
  const avg = items.length ? (items.reduce((a, i) => a + i.rating, 0) / items.length).toFixed(1) : null;
  const byStore = stores.map((s) => { const rows = items.filter((i) => i.store_id === s.id); return { ...s, count: rows.length, avg: rows.length ? (rows.reduce((a, i) => a + i.rating, 0) / rows.length).toFixed(1) : null }; });

  return (
    <div className="p-6 lg:p-10">
      <PageHeader eyebrow="Company" title="Customer Feedback" testId="company-feedback-title"
        subtitle={avg ? `${avg} ★ average across ${items.length} review${items.length !== 1 ? "s" : ""}` : "No reviews yet"}
        actions={<>
          <Select value={storeId} onChange={(e) => setStoreId(e.target.value)} data-testid="feedback-store-filter"><option value="">All stores</option>{stores.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</Select>
          <Select value={rating} onChange={(e) => setRating(e.target.value)} data-testid="feedback-rating-filter"><option value="">All ratings</option>{[5, 4, 3, 2, 1].map((n) => <option key={n} value={n}>{n} ★</option>)}</Select>
        </>}
      />
      {!storeId && (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-8">
          {byStore.map((s) => (
            <Link key={s.id} to={`/admin/stores/${s.id}/feedback`} className="rounded-xl border border-neutral-200 bg-white p-4 hover:shadow-sm" data-testid={`feedback-store-${s.id}`}>
              <div className="font-medium text-sm">{s.name}</div>
              <div className="flex items-center gap-2 mt-1"><span className="font-display font-bold text-xl">{s.avg ?? "—"}</span>{s.avg && <Stars value={Math.round(s.avg)} size="w-3.5 h-3.5"/>}<span className="text-xs text-neutral-400">{s.count} reviews</span></div>
            </Link>
          ))}
        </div>
      )}
      <Panel className="divide-y divide-neutral-100">
        {shown.length === 0 && <p className="p-10 text-center text-sm text-neutral-500" data-testid="company-feedback-empty">No feedback matches.</p>}
        {shown.map((f) => (
          <div key={f.id} className="p-4 text-sm flex items-start justify-between gap-4" data-testid={`company-feedback-${f.id}`}>
            <div className="min-w-0">
              <div className="flex items-center gap-2"><Stars value={f.rating}/><Link to={`/admin/stores/${f.store_id}/feedback`} className="text-xs font-medium text-[hsl(var(--primary))]">{f.store_name}</Link></div>
              {f.comment && <p className="mt-1 text-neutral-700">{f.comment}</p>}
              <div className="text-xs text-neutral-400 mt-1">{f.name || f.email || "Anonymous"}{f.user_id && <> · <Link to={`/admin/customers/${f.user_id}`} className="underline">profile</Link></>}</div>
            </div>
            <div className="text-xs text-neutral-500 whitespace-nowrap">{fmtDT(f.created_at)}</div>
          </div>
        ))}
      </Panel>
    </div>
  );
}
